import { Download } from "lucide-react";

const FILES = [
  ["logo-transparente.png", "Logo completo", "fondo transparente"],
  ["logo-crema.png", "Logo completo", "fondo crema"],
  ["logo-icono-transparente.png", "Icono", "fondo transparente"],
  ["logo-icono-crema.png", "Icono (perfil de WhatsApp o Instagram)", "fondo crema"],
];

export const BrandDownloads = () => (
  <section data-testid="brand-downloads" className="mt-8 bg-white rounded-2xl p-5 sm:p-6">
    <p className="font-display text-xl">Tu logo</p>
    <p className="text-sm text-[#5a4f46] mt-1">Descárgalo en PNG para tu perfil de WhatsApp Business, Instagram o tus publicaciones.</p>
    <div className="mt-4 grid grid-cols-2 lg:grid-cols-4 gap-3">
      {FILES.map(([file, title, bg], i) => (
        <a key={file} href={`/${file}`} download data-testid={`download-logo-${i}`}
          className="rounded-xl border-2 border-[#eadfce] hover:border-[var(--ink)] p-3 flex flex-col gap-2 transition-colors">
          <div className={`h-20 rounded-lg grid place-items-center p-2 ${bg.includes("crema") ? "bg-[var(--cream)]" : "bg-[repeating-conic-gradient(#eee_0%_25%,#fff_0%_50%)] bg-[length:16px_16px]"}`}>
            <img src={`/${file}`} alt={title} className="max-h-full max-w-full object-contain" />
          </div>
          <span className="text-sm font-semibold leading-tight">{title}</span>
          <span className="text-xs text-[#7a6c5e] inline-flex items-center gap-1"><Download size={12} /> {bg}</span>
        </a>
      ))}
    </div>
  </section>
);
